import PermissionCard from '@/pages/backend/PermissionConfig/PermissionCard';
import { EPermissionGroupType } from '@/models/PermissionGroup';
import cx from 'classnames';

const PermissionConfig = () => {
  return (
    <div className={cx('m-[24px]')}>
      <div className={cx('text-base', 'font-medium')}>
        权限管理
      </div>
      <div className={cx('mt-[24px]')}>
        <PermissionCard
          title={'谁可以新建打卡营'}
          subTitle={'点击下方区域修改权限组人员，超级管理员默认有此权限，无需选择'}
          type={EPermissionGroupType.CREATE_CAMP}
        />
        <PermissionCard
          title={'谁可以管理所有打卡营'}
          subTitle={'点击下方区域修改权限组人员，超级管理员默认有此权限，无需选择'}
          type={EPermissionGroupType.MANAGE_CAMP}
        />
        <PermissionCard
          title={'谁可以使用题库管理'}
          subTitle={'点击下方区域修改权限组人员，超级管理员默认有此权限，无需选择'}
          type={EPermissionGroupType.MANAGE_QUESTION_BANK}
        />
      </div>
    </div>
  );
};

export default PermissionConfig;